import { DDDFreespinBetPresentation } from "../freespin/DDDFreespinBetPresentation";

export class DDDSuperFreespinBetPresentation extends DDDFreespinBetPresentation {
    constructor(protected id: string = `DDDSuperFreespinBetPresentation`) {
        super(id);
    }
}
